import PropTypes from 'prop-types';
import React from 'react';
import CustomComponent from '../custom/CustomComponent';
import { injectIframeAspects } from '../utils/NextGenIframeUtil/NextGenIframeUtil';

const iframeOptions = {
    checkOrigin: false,
    inPageLinks: true,
    heightCalculationMethod: 'lowestElement',
};
const componentConfig = {
    type: 'uncontrolled-iframe',
};
const iframeHeight = 600;
const isDevelopmentEnvironment = process.env.NODE_ENV === 'development';
export const iframeClassName = 'nextGenAppContainer';

export const NextGenAppContainer = ({ title, url, dbkSession }) => {
    const handleIframeLoad = () => {
        console.log(`${title} loaded.`);

        const { experienceAspects = [] } = window || {};
        const iframeAspects = experienceAspects.filter((a) => a?.isIFrame);

        if (iframeAspects.length > 0) {
            injectIframeAspects(
                dbkSession,
                `.${iframeClassName}`,
                iframeAspects,
            );
        }
    };

    return (
        <CustomComponent
            className={iframeClassName}
            onIframeLoad={handleIframeLoad}
            config={{ ...componentConfig, url }}
            resourceVersion={window.di.env.buildNumber}
            iframeHeight={iframeHeight}
            iframeId="appContainer"
            title={title}
            {...(isDevelopmentEnvironment && {
                allowDomains: ['localhost'],
            })}
            resizerOptions={iframeOptions}
        />
    );
};

NextGenAppContainer.propTypes = {
    /**
     * String to add title attribute to the iFrame.
     */
    title: PropTypes.string.isRequired,
    /**
     * String to load as url in Iframe.
     */
    url: PropTypes.string.isRequired,
    /**
     * DBKSessionInfo object
     */
    dbkSession: PropTypes.object.isRequired,
};
